import SalesTrendComponent from './SalesTrend';

const SalesTrend = SalesTrendComponent;

export default SalesTrend;
